module.exports = __webpack_public_path__ + "img/use_ear_protection.7fb6e650.svg";